module.exports = __webpack_public_path__ + "static/media/8.3c4d2559.jpg";